<!--   Share Button
       Masaüstü/mobil tetikleyici ayrımı SCSS'te; bkz. share-button.component.scss
       sonundaki ngx-layout/SSR notu. Eskiden *ngIf="!getIsMobile() else ..." idi.
       İki tetikleyici TEK mat-menu'yü paylaşamaz (MatMenu tek _previousTrigger
       tutar), bu yüzden iki ayrı menü var; içerik #shareMenuItems'tan gelir. -->
<ng-container *ngIf="staticShare else staticTemplate">
    <button mat-stroked-button
            color="primary"
            [matMenuTriggerFor]="desktopShareMenu"
            class="small-button event-share-button share-desktop-only">

        <mat-icon>share</mat-icon>
        <span *ngIf="showText">{{'shared.labels.share'|translate}}</span>
    </button>

    <button class="mobile-share-button share-mobile-only"
            mat-fab
            [matMenuTriggerFor]="mobileShareMenu">
        <mat-icon>share</mat-icon>
    </button>
</ng-container>

<ng-template #staticTemplate>
    <button mat-stroked-button
            color="primary"
            [matMenuTriggerFor]="desktopShareMenu"
            class="small-button event-share-button">

        <mat-icon>share</mat-icon>
        <span *ngIf="showText">{{'shared.labels.share'|translate}}</span>
    </button>
</ng-template>

<!-- Menü içeriği tek yerde tanımlanır, iki menüye ngTemplateOutlet ile verilir. -->
<ng-template #shareMenuItems>

    <button mat-menu-item disabled
            *ngIf="showText">
        {{menuTitle}}
    </button>

    <ng-container *ngFor="let linkItem of shareLinkItems">
        <a *ngIf="isLinkVisible(linkItem)"
           mat-menu-item
           (click)="onClickShareLinkItem(linkItem)">
            <mat-icon *ngIf="showIcon" [svgIcon]="linkItem.icon"></mat-icon>
            <span *ngIf="showText">{{linkItem.text|translate}}</span>
        </a>
    </ng-container>

</ng-template>

<mat-menu #desktopShareMenu="matMenu">
    <ng-container *ngTemplateOutlet="shareMenuItems"></ng-container>
</mat-menu>

<mat-menu #mobileShareMenu="matMenu">
    <ng-container *ngTemplateOutlet="shareMenuItems"></ng-container>
</mat-menu>
